import { Injectable } from '@angular/core';
import { DataSourceItemMetadataBase } from '../../../common-shared-module/model/dyn-form/form-metadata/item/datasource-item-metadata.model';
import { DataSourceOptionMetadataBase } from '../../../common-shared-module/model/dyn-form/form-metadata/item/datasource-option-item-metadata.model';
import { CSVParseResult } from '../../models/csv-parse-result.model';

@Injectable({
    providedIn: 'root'
})
export class CsvParserService {

    protected transformCsv(rawCsv: string, columnsCount: number): CSVParseResult {
        let result: CSVParseResult = { ok: true, lines: [], message: "" }
        let content = rawCsv
        let lines = content.split("\n")
        if (lines.length <= 0) {
            result.ok = false
            result.message = "No hi han dades per importar"
            return result
        }

        for (let index = 0; index < lines.length; index++) {
            const element = lines[index];
            let currentLineContainer: string[] = []
            result.lines.push(currentLineContainer)
            let currentLine = this.parseLine(element)

            if (currentLine.length != columnsCount) {
                result.ok = false
                result.message = `La línia ${index} ha de tenir ${columnsCount} columnes separades per ';' `
                return result
            }
            for (let lineIndex = 0; lineIndex < currentLine.length; lineIndex++) {
                const elementLine = currentLine[lineIndex];
                currentLineContainer.push(elementLine)
            }
        }

        return result
    }

    protected parseLine(line: string): string[] {
        return line.split(";")
    }

    createOptions(rawCsv: string, family: DataSourceItemMetadataBase[]): CSVParseResult {

        let result = this.transformCsv(rawCsv, family.length)
        if (result.ok == false) {
            return result
        }
        //clear all options:
        family.forEach(dataSourceItemMetadata => {
            dataSourceItemMetadata.clear()
        })

        for (let index = 0; index < result.lines.length; index++) {
            const line = result.lines[index];
            for (let lineIndex = 0; lineIndex < line.length; lineIndex++) {
                const column = line[lineIndex];
                if (lineIndex == 0) {

                    let option: DataSourceOptionMetadataBase = new DataSourceOptionMetadataBase();
                    let optionIndex = family[lineIndex].options.findIndex(p => p.id == column)
                    if (optionIndex >= 0) {
                        continue;
                    }
                    option.id = column
                    option.value = column
                    family[lineIndex].options.push(option)
                    continue
                }

                let ds = family[lineIndex]
                let option: DataSourceOptionMetadataBase = new DataSourceOptionMetadataBase();
                option.id = column
                option.value = column
                ds.addDataSourceOptionMetadataForParentId(line[lineIndex - 1], option)
            }
        }

        return result

    }


    calculateCsv(family: DataSourceItemMetadataBase[]): string {

        let result = ""
        let currentLines: string[][] = []

        this.calculateCsvLine(0, family, currentLines, [])

        for (let index = 0; index < currentLines.length; index++) {
            const line = currentLines[index];
            if (index < currentLines.length - 1) {
                result = result + line.join(";") + "\n"
            } else {
                result = result + line.join(";")
            }

        }


        return result
    }

    calculateCsvLine(index: number, family: DataSourceItemMetadataBase[], currentLineContainer: string[][], currentLine: string[]) {
        for (let i = 0; i < family.length; i++) {
            const dataSourceOption = family[i];
            if (index == family.length - 1) {
                let currentOptions = dataSourceOption.dependentOptions.get(currentLine[currentLine.length - 1])
                if (currentOptions == null) {
                    continue
                }
                for (let i2 = 0; i2 < currentOptions.length; i2++) {
                    const option = currentOptions[i2];
                    let line: string[] = []
                    currentLine.forEach(p => { line.push(p) })
                    line.push(option.id)
                    currentLineContainer.push(line)
                }
                return
            }
            if (index == 0) {
                const dataSourceOption = family[i];
                for (let i3 = 0; i3 < dataSourceOption.options.length; i3++) {
                    const element = dataSourceOption.options[i3];
                    let line: string[] = []
                    currentLine.forEach(p => { line.push(p) })
                    line.push(element.id)
                    this.calculateCsvLine(index + 1, family, currentLineContainer, line)
                }
                return
            }

            const dataSourceOption2 = family[i];
            let currentOptions = dataSourceOption2.dependentOptions.get(currentLine[currentLine.length - 1])
            if (currentOptions == null) {
                continue
            }
            for (let i3 = 0; i3 < currentOptions.length; i3++) {
                const element = currentOptions[i3];
                let line: string[] = []
                currentLine.forEach(p => { line.push(p) })
                line.push(element.id)
                this.calculateCsvLine(index + 1, family, currentLineContainer, line)
            }
        }
    }

}
